import React from 'react'
import ReactMarkdown from 'react-markdown'

function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}

const ListItem = ({ data }) => {

    const scheduleDate = new Date(data.schedule)
    
    return (
        <div>
            <div className="shadow-lg bg-white p-6">
                { data.title && <h3 className="h3">{data.title}</h3> }
                <p>{ scheduleDate.getDate()} {scheduleDate.toLocaleString('en-en', { month: 'long' }) } { scheduleDate.getFullYear() }</p>
                <ReactMarkdown children={ data.description } />
            </div>
        </div>
    )
}

export default ListItem
